
namespace TerminalApp {

 

    export class PlacementPickerAssistant {
        container = document.createElement("div");
        header_html = document.createElement("div");
        stock_menu = document.createElement("div");
        hall_menu = document.createElement("div");
        section_menu = document.createElement("div");
        unit_menu = document.createElement("div");
        placement_menu = document.createElement("div");

        stock_suggestion_container = document.createElement("div");
        hall_suggestion_container = document.createElement("div");
        section_suggestion_container = document.createElement("div");
        unit_suggestion_container = document.createElement("div");
        placement_suggestion_container = document.createElement("div");

        stockId: string;
        stockHall: SP.StockHall;
        stockSection: SP.StockSection;
        stockUnit: SP.StockUnit;
        stockPlacement: SP.StockPlacement;
        callback: (itemInfo: SP.StockPlacement) => void;
        constructor() {
            this.container.classList.add("assistant");

            //close button
            var close_button = this.container.appendChild(document.createElement("div"))
            close_button.classList.add("close");
            close_button.innerHTML = "X";
            close_button.addEventListener("click", () => {
                this.close();
            });

            this.container.appendChild(this.header_html);

            //setup stock screen
            var stock_headline = this.stock_menu.appendChild(document.createElement("h1"));
            stock_headline.innerHTML = SP.Localize("sentance_select_stock") + " / " + SP.Localize("sentance_scan_placement");
            this.stock_menu.append(this.stock_suggestion_container);

            //setup hall screen
            var hall_headline = this.hall_menu.appendChild(document.createElement("h1"));
            hall_headline.innerHTML = SP.Localize("sentance_select_hall") + " / " + SP.Localize("sentance_scan_placement");
            this.hall_menu.append(this.hall_suggestion_container);

            //setup section screen
            var section_headline = this.section_menu.appendChild(document.createElement("h1"));
            section_headline.innerHTML = SP.Localize("sentance_select_section") + " / " + SP.Localize("sentance_scan_placement");
            this.section_menu.appendChild(this.section_suggestion_container);

            //setup unit screen
            var unit_headline = this.unit_menu.appendChild(document.createElement("h1"));
            unit_headline.innerHTML = SP.Localize("sentance_select_unit") + " / " + SP.Localize("sentance_scan_placement");
            this.unit_menu.appendChild(this.unit_suggestion_container);

            //setup placement screen
            var placement_headline = this.placement_menu.appendChild(document.createElement("h1"));
            placement_headline.innerHTML = SP.Localize("sentance_scan_tote") + " / " + SP.Localize("sentance_scan_placement");
            this.placement_menu.appendChild(this.placement_suggestion_container);

            this.container.appendChild(this.stock_menu);
            this.container.appendChild(this.hall_menu);
            this.container.appendChild(this.section_menu);
            this.container.appendChild(this.unit_menu);
            this.container.appendChild(this.placement_menu);
        }

        hide() {
            this.stock_menu.style.display = "none";
            this.hall_menu.style.display = "none";
            this.section_menu.style.display = "none";
            this.unit_menu.style.display = "none";
            this.placement_menu.style.display = "none";
            this.container.style.display = "none";
        }

        async open_customer_picker() {
            this.hide();
            this.container.style.display = "block";
            this.stock_menu.style.display = "block";
            let customers = await SP.Data.Customer.getCustomerInfos();
            this.stock_suggestion_container.innerHTML = "";

            if (customers.length == 1) return this.open_hall_picker(customers[0].stockId);
            customers.forEach(customer => {
                this.addCustomer(customer);
            });
        }

        async open_hall_picker(stockId: string) {
            this.hide();
            this.container.style.display = "block";
            this.hall_menu.style.display = "block";
            this.stockId = stockId;
            let halls = await SP.Data.Stock.getHalls(stockId);

            this.hall_suggestion_container.innerHTML = "";
            halls.forEach(hall => {
                this.addHall(hall);
            });
        }

        async open_section_picker(hallId: string) {
            this.hide();
            this.container.style.display = "block";
            this.section_menu.style.display = "block";

            let sections = await SP.Data.Stock.getSections(hallId);
            this.section_suggestion_container.innerHTML = "";
            sections.forEach(section => {
                this.addSection(section);
            });
        }

        async open_unit_picker(sectionId: string) {
            this.hide();
            this.container.style.display = "block";
            this.unit_menu.style.display = "block";
            let units = await SP.Data.Stock.getUnits(sectionId)
            this.unit_suggestion_container.innerHTML = "";
            units.forEach(unit => {
                this.addUnit(unit);
            });
        }

        async open_placement_picker(unitId: string) {
            this.hide();
            this.container.style.display = "block";
            this.placement_menu.style.display = "block";
            let placements = await SP.Data.Stock.getPlacements(unitId)
            this.placement_suggestion_container.innerHTML = "";
            placements.forEach(placement => {
                this.addPlacement(placement);
            });
        }

        clear() {
            this.hall_suggestion_container.innerHTML = "";
            this.section_suggestion_container.innerHTML = "";
            this.unit_suggestion_container.innerHTML = "";
            this.placement_suggestion_container.innerHTML = "";
            this.container.style.display = "none";
        }

        bound: boolean = false;

        async open(customerId: string, headerHtml: string, callback: (placementInfo: SP.StockPlacement) => void) {
            this.header_html.innerHTML = "";
            if (headerHtml) this.header_html.innerHTML = headerHtml;


            if (!this.bound) {
                this.bound = true;
                barcodeListener.on("sp", this.scanStockPlacement, this);
                barcodeListener.on("t", this.scanTote, this);
            }

            this.clear();

            this.callback = callback;
            if (customerId) {
                var ci = await SP.Data.Customer.getCustomerInfo(customerId);
                this.open_hall_picker(ci.stockId);
            }
            else {
                this.open_customer_picker();
            }
        }



        close() {
            if (this.bound) {
                this.bound = false;
                barcodeListener.off("sp", this.scanStockPlacement);
                barcodeListener.off("t", this.scanTote);
            }
            this.clear();
            this.container.style.display = "none";
        }

        scanStockPlacement(locationId: string) {
            SP.Data.Stock.getPlacementInfo(parseInt(locationId), false).then((item) => {
                if (item) {
                    if (this.callback) this.callback(item.placement);
                    this.close();
                }
                else {
                    SP.alertX("stockplacement not found!");
                }
            });
            
            return false;
        }

        addCustomer(item: SP.CustomerInfo) {
            var c = this.stock_suggestion_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");
            c.innerHTML = `<div class='action'>${item.customerName}</div>`;
            c.addEventListener("click", () => {
                this.stockId = item.stockId;
                this.open_hall_picker(this.stockId);
            });
        }


        addHall(item: SP.StockHall) {
            var c = this.hall_suggestion_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");
            c.innerHTML = `<div class='action'>${SP.Localize("word_hall")} ${item.name}</div>`;
            c.addEventListener("click", () => {
                this.stockHall = item;
                this.open_section_picker(item.id);
            });
        }

        addSection(item: SP.StockSection) {
            var c = this.section_suggestion_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");
            c.innerHTML = `<div class='action'>${SP.Localize("word_section")} ${item.name}</div>`;
            c.addEventListener("click", () => {
                this.stockSection = item;
                this.open_unit_picker(item.id);
            });
        }

        addUnit(item: SP.StockUnit) {
            var c = this.unit_suggestion_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");
            c.innerHTML = `<div class='action'>${this.stockSection.name} ${item.number.toString().padStart(2, "0")}</div>`;
            c.addEventListener("click", () => {
                this.stockUnit = item;
                this.open_placement_picker(item.id);
            });
        }

        addPlacement(item: SP.StockPlacement) {
            var c = this.placement_suggestion_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");

            var value = `${item.row.toString().padStart(2, "0")} - ${item.number.toString().padStart(2, "0")}`;

            if (item.sub) value += ` (${item.sub.toString().padStart(2, "0")})`;

            c.innerHTML = `<div class='action'>${value}</div>`;
            if (item.row !== undefined)
                c.addEventListener("click", () => {
                    console.log("CLICK", item);
                if (this.callback) this.callback(item);
                this.close();
            });
        }

        scanTote(toteId: string) {
            SP.Data.Tote.getToteInfo(toteId, false).then((t) => {
                if (t) {
                    this.scanStockPlacement(t.totePlacementId.toString());
                }
            });
            return false;
        }
    }

    export class ToteAndPlacementPickerAssistant extends PlacementPickerAssistant {
        tote_menu = document.createElement("div");
        tote_container = document.createElement("div");
        tote_placeholder = document.createElement("div");
        tote_ids: number[] = [];

        constructor() {
            super();
            //setup stock screen
            var tote_headline = this.tote_menu.appendChild(document.createElement("h1"));
            tote_headline.innerHTML = SP.Localize("sentance_scan_totes");
            this.tote_menu.append(this.tote_container);
            this.container.prepend(this.tote_menu);
            this.tote_placeholder.style.textAlign = "center";
            this.tote_placeholder.innerHTML = "<br / ><br /><img src='/terminal/img/scan.png' >"
            this.tote_menu.append(this.tote_placeholder);

 
        }

        clearTotes() {
            this.tote_container.innerHTML = "";
            this.tote_ids = [];
            this.tote_placeholder.style.display = "block";
        }

        async openWithTotes(toteIds: number[], stockId: string, cb: (placementInfo: SP.StockPlacement) => void) {
            this.clearTotes();
            //this.tote_ids = toteIds;

            await super.open(stockId, null, cb);

            var toteInfos = await SP.Data.Tote.getToteInfos(toteIds, false);
            toteInfos.forEach(ti => this.addTote(ti));

        }


        addTote(t: SP.ToteInfo) {
            if (this.tote_ids.indexOf(t.toteId) != -1) return;

            this.tote_ids.push(t.toteId);
            var box = new ToteBox(t);
            box.container.addEventListener("click", () => {
                console.log("removing tote " + t.toteId);
                this.tote_ids.splice(this.tote_ids.indexOf(t.toteId), 1);
                box.container.remove();
                if (!this.tote_ids.length) this.tote_placeholder.style.display = "block";
            });


            this.tote_container.append(box.container);
            this.tote_placeholder.style.display = "none";



        }


        close() {
            super.close();
            this.clear();
            this.container.style.display = "none";
        }

        scanTote(toteId: string) {
            SP.Data.Tote.getToteInfo(toteId, false).then((t) => {
                if (t) {
                    this.addTote(t);
                }
                else {
                    SP.alertX("tote not found!");
                }
            });
            return false;
        }
    }
}